import lrTime from './_src/lrTime.vue'

lrTime.install = function(Vue) {
  Vue.component(lrTime.name, lrTime)
}

export default lrTime